// ----------------------------------------------------------------------

const account = {
  displayName: 'The Lalit Mumbai',
  email: 'demo@minimals.cc',
  photoURL: 'https://media-cdn.tripadvisor.com/media/photo-s/1d/10/99/d0/swimming-pool.jpg',
};

export default account;
